import { ILight } from '../lightTemplate';

type IHemisphereLightProps = {
  instanceId: string;
  castShadow?: boolean;
  light?: ILight | undefined;
};

export const HemisphereLight = (props: IHemisphereLightProps) => {
  const lightRef = props.light?.ref;

  return (
    <>
      <hemisphereLight
        ref={lightRef}
        color={props.light?.color !== undefined ? props.light.color : 0xffffff}
        groundColor={
          props.light?.groundColor !== undefined
            ? props.light.groundColor
            : 0xffffff
        }
        intensity={
          props.light?.intensity !== undefined ? props.light.intensity : 5
        }
        position={[0, 0, 0]}
        key={`light-${props.instanceId}`}
      />
    </>
  );
};
